import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/AxiosInstance";

export const fetchHouseSummaryReportThunk = createAsyncThunk(
  "houseSummaryReport/fetch",
  async (filters, { rejectWithValue }) => {
    try {
      const params = {
        ward_id: filters?.ward_id || "",
        mtr_type: filters?.mtr_type || "",
        only_water_yes: filters?.only_water_yes || "", // "1" or ""
        due_filter: filters?.due_filter || "",
      };

      const res = await api.get("/api/reports/house-summary-report", { params });

      if (!res.data?.success) {
        return rejectWithValue(res.data?.message || "Failed to load report");
      }

      return {
        rows: res.data?.data || [],
        totals: res.data?.totals || null,
      };
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || err.message || "Server error");
    }
  }
);

const houseSummaryReportSlice = createSlice({
  name: "houseSummaryReport",
  initialState: {
    rows: [],
    totals: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearHouseSummaryReport: (state) => {
      state.rows = [];
      state.totals = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHouseSummaryReportThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchHouseSummaryReportThunk.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload?.rows || [];
        state.totals = action.payload?.totals || null;
      })
      .addCase(fetchHouseSummaryReportThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load report";
      });
  },
});

export const { clearHouseSummaryReport } = houseSummaryReportSlice.actions;
export default houseSummaryReportSlice.reducer;
